import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import {RouterProvider} from "react-router-dom";
import router from "./router.jsx";
import {ContextProvider} from './context/ContextProvider.jsx'
import { ChakraProvider } from '@chakra-ui/react';
import theme from './theme';
import Loader from './components/Loader';
import "./i18n";

// ── Global Anti-Autofill System ──────────────────────────────────────────────
if (typeof document !== 'undefined') {
  const disableAutofill = (el) => {
    if (el && el.tagName === 'INPUT') {
      const type = el.getAttribute('type');
      if (type === 'password') {
        if (!el.hasAttribute('autocomplete')) {
          el.setAttribute('autocomplete', 'new-password');
        }
      } else {
        if (!el.hasAttribute('autocomplete')) {
          // Applies "one-time-code" to all other input types (number, tel, text, email, etc.)
          // to bypass modern browser heuristics that ignore "off".
          el.setAttribute('autocomplete', 'one-time-code');
        }
      }
    }
  };

  // Scan initially rendered inputs
  document.querySelectorAll('input').forEach(disableAutofill);

  // Intercept dynamically added inputs (React page changes, modals, sheets)
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          if (node.tagName === 'INPUT') {
            disableAutofill(node);
          } else if (node.querySelectorAll) {
            node.querySelectorAll('input').forEach(disableAutofill);
          }
        }
      });
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
  <ChakraProvider theme={theme}> 
    <ContextProvider>
     <Loader />
     <RouterProvider router={router} />
    </ContextProvider>
  </ChakraProvider> 
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals()